export interface IPurchaserBrandAssociation {
  brandId: number;
  brandName: string;
  brandKey: string;
  brandPurchaserId: number;
  purchaserInboxEmailId: string | null;
  isActive: boolean;
}

export class PurchaserBrandAssociation implements IPurchaserBrandAssociation {
  private readonly _brandId: number;
  private readonly _brandName: string;
  private readonly _brandKey: string;
  private readonly _brandPurchaserId: number;
  private readonly _purchaserInboxEmailId: string | null;
  private readonly _isActive: boolean;

  constructor(props: IPurchaserBrandAssociation) {
    this._brandId = props.brandId;
    this._brandName = props.brandName;
    this._brandKey = props.brandKey;
    this._brandPurchaserId = props.brandPurchaserId;
    this._purchaserInboxEmailId = props.purchaserInboxEmailId;
    this._isActive = props.isActive;
  }

  get brandId(): number {
    return this._brandId;
  }

  get brandName(): string {
    return this._brandName;
  }

  get brandKey(): string {
    return this._brandKey;
  }

  get brandPurchaserId(): number {
    return this._brandPurchaserId;
  }

  get purchaserInboxEmailId(): string | null {
    return this._purchaserInboxEmailId;
  }

  get isActive(): boolean {
    return this._isActive;
  }

  static from(props: IPurchaserBrandAssociation): PurchaserBrandAssociation {
    return new PurchaserBrandAssociation(props);
  }
}
